import React from 'react';

import { H3, Icon, ListRow, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../../../Shared/urlBuilder';
import { PurposeProjectionQuery } from '../graphql/purposeProjection.generated';

export const ForecasterLink: React.FC<{ purpose: PurposeProjectionQuery['purpose'] }> = ({ purpose }) => {
  const linkText = () => {
    if (purpose.__typename === 'PurposeRetirementIncome') {
      return 'Preview your withdrawal plan';
    }

    if (purpose.__typename === 'PurposeRetirementGrowth' && !purpose.financialProfile?.retirementAssumptions) {
      return 'See what you’ll need to retire';
    }

    return 'See how your money can grow';
  };

  const forecaterLinkTile = (
    <ListRow
      css={{
        border: 'token(colors.border) solid token(borderWidths.thin)',
        padding: 'space.200',
        borderRadius: 'large',
      }}
    >
      <ListRow.LeadingAsset>
        <Icon name="Guidance" size="small" color="icon.accent.gold" />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <H3 variant="title100">Forecaster</H3>
        <Text variant="text50">{linkText()}</Text>
      </ListRow.LeadingContent>
      <ListRow.TrailingAsset>
        <Icon name="CaretRight" size="small" />
      </ListRow.TrailingAsset>
    </ListRow>
  );

  if (purpose.__typename === 'PurposeRetirementGrowth' && !purpose.financialProfile?.retirementAssumptions) {
    return (
      <SambaAutoLink
        to={urlBuilder.appGoalsEditPurpose.absolute({ goal_id: purpose.goalId, return_to: window.location.pathname })}
        css={{ color: 'text', width: '100%' }}
      >
        {forecaterLinkTile}
      </SambaAutoLink>
    );
  }

  return (
    <SambaAutoLink
      to={urlBuilder.appPurposeForecaster.absolute({ purposeId: purpose.id })}
      css={{ color: 'text', width: '100%' }}
    >
      {forecaterLinkTile}
    </SambaAutoLink>
  );
};
